// extracted by mini-css-extract-plugin
export default {"formPercentageCircle":"FormPercentageCircle_formPercentageCircle__7cbby"};